module.exports = __webpack_public_path__ + "static/tegar2-264082e9c8f1ad35160376c1c30a0034.png";